// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__20WAG","cell":"ColumnAccessor_cell__3na2Y","firstCellAccent":"ColumnAccessor_firstCellAccent__C1UK4"};